import './styles.scss';

import React, { FC, useState } from 'react';

import { FooterLinkModel } from '../../../../models/footerLink.model';
import Icon from '../../../@shared/icon';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { TFooterLink } from '../../../../types/footerLink.types';
import { TLinksAccordionProps } from './types/linksAccordion.types';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { iconSize } from '../../../../constants/icon.constants';
import { windowService } from '../../../../utils/window.utils';
import useEEActive from '../../../../hooks/useEEActive';
import { checkIsHrefValid } from '../../../../utils/checkIsHrefValid.utils';
import { googleNavClickEvent } from '../../../../utils/analytics';
import { footerMenu } from '../../../../constants/analytics.constants';

const LinksAccordion: FC<TLinksAccordionProps> = ({ fields }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const isEE = useEEActive();
  if (!fields) {
    return null;
  }
  const mobileBreakpoint = 768;

  const onAccordionClick = (): void => {
    if (windowService().innerWidth <= mobileBreakpoint) {
      setIsCollapsed(!isCollapsed);
    }
  };

  const model = new FooterLinkModel(fields);
  const links = model?.list.map((item: TFooterLink) => (
    <li key={item?.id} className="footer-accordion__item">
      <RoutableSitecoreLink
        field={item?.fields?.link}
        className="footer-accordion__link"
        onClick={() =>
          googleNavClickEvent(
            footerMenu,
            item?.fields?.link?.value?.href,
            item?.fields?.link?.value?.text || item?.fields?.link?.value?.title
          )
        }
      />
    </li>
  ));

  return (
    <div className="footer-accordion">
      <div className="footer-accordion__button-section">
        <button className="footer-accordion__button" onClick={onAccordionClick}>
          <Icon
            extraClassName="footer-accordion__icon"
            iconName={isCollapsed ? 'arrow-chevron-down' : 'arrow-chevron-up'}
            size={iconSize.mbl}
          />
        </button>
        {isEE && <RoutableSitecoreLink field={model?.link} className={'footer-accordion__header--link'} />}
        {!isEE &&
          model?.groupTitle &&
          (checkIsHrefValid(model?.link?.value?.href) ? (
            <RoutableSitecoreLink field={model?.link} className={'footer-accordion__header footer-accordion__header--link'} />
          ) : (
            <RichText field={{ value: model?.groupTitle }} className={'footer-accordion__header'} />
          ))}
      </div>
      <ul className={`footer-accordion__list ${isCollapsed ? 'footer-accordion__list--collapsed' : ''}`}>{links}</ul>
    </div>
  );
};

export default LinksAccordion;
